let initialState = {
  isRedirection: false,
  isSearchPage: false
};

export default function myJioDataReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_MYJIO_APP_DATA': {
      return { ...state, ...action.payload };
    }

    default:
      return state;
  }
}
